import { useDisclosure as useBaseDisclosure } from '@mantine/hooks'

export const useDisclosure = useBaseDisclosure
